module.exports = __webpack_public_path__ + "img/switcheo-small.bfb4d820.svg";